import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { useState } from 'react';
import { createAppRouter, createQueryClient } from './router.js';

export function App() {
  const [router] = useState(createAppRouter);
  const [queryClient] = useState(() =>
    createQueryClient(() => {
      queryClient.clear();
      void router.navigate({ to: '/login' });
    }),
  );
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  );
}
